<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :append-icon="toggle ? 'mdi-eye' : 'mdi-eye-off'"
    :type="toggle ? 'text' : 'password'"
    @click:append="toggle = !toggle"
  ></v-text-field>
</template>

<script>
import { ref } from '@vue/composition-api';

export default {
  name: 'PasswordField',
  setup() {
    const toggle = ref(false);

    return {
      toggle
    };
  }
};
</script>
